/**********************************************************************************
* GENERATED FILE - This file is automatically managed by the MJ CodeGen tool, 
* 
* DO NOT MODIFY THIS FILE - any changes you make will be wiped out the next time the file is
* generated
* 
**********************************************************************************/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// MemberJunction Imports
import { BaseFormsModule } from '@memberjunction/ng-base-forms';
import { EntityViewerModule } from '@memberjunction/ng-entity-viewer';
import { LinkDirectivesModule } from '@memberjunction/ng-link-directives';

// Import Generated Components
import { IzzyAssignmentRuleFormComponent } from "./Entities/IzzyAssignmentRule/izzyassignmentrule.form.component";
import { IzzyAutomationRuleFormComponent } from "./Entities/IzzyAutomationRule/izzyautomationrule.form.component";
import { IzzyChannelActionFormComponent } from "./Entities/IzzyChannelAction/izzychannelaction.form.component";
import { IzzyChannelExtensionFormComponent } from "./Entities/IzzyChannelExtension/izzychannelextension.form.component";
import { IzzyChannelMessageAttachmentFormComponent } from "./Entities/IzzyChannelMessageAttachment/izzychannelmessageattachment.form.component";
import { IzzyChannelMessageFormComponent } from "./Entities/IzzyChannelMessage/izzychannelmessage.form.component";
import { IzzyChannelMessageNoteFormComponent } from "./Entities/IzzyChannelMessageNote/izzychannelmessagenote.form.component";
import { IzzyChannelTypeActionFormComponent } from "./Entities/IzzyChannelTypeAction/izzychanneltypeaction.form.component";
import { IzzyChannelTypeExtensionFormComponent } from "./Entities/IzzyChannelTypeExtension/izzychanneltypeextension.form.component";
import { IzzyCredentialExtensionFormComponent } from "./Entities/IzzyCredentialExtension/izzycredentialextension.form.component";
import { IzzyCredentialTypeExtensionFormComponent } from "./Entities/IzzyCredentialTypeExtension/izzycredentialtypeextension.form.component";
import { IzzyIssueTicketNumberFormComponent } from "./Entities/IzzyIssueTicketNumber/izzyissueticketnumber.form.component";
import { IzzyIzzyActionCategoryFormComponent } from "./Entities/IzzyIzzyActionCategory/izzyizzyactioncategory.form.component";
import { IzzyIzzyActionFormComponent } from "./Entities/IzzyIzzyAction/izzyizzyaction.form.component";
import { IzzyIzzyActionOrganizationFormComponent } from "./Entities/IzzyIzzyActionOrganization/izzyizzyactionorganization.form.component";
import { IzzyMacroFormComponent } from "./Entities/IzzyMacro/izzymacro.form.component";
import { IzzyOrganizationActionFormComponent } from "./Entities/IzzyOrganizationAction/izzyorganizationaction.form.component";
import { IzzyPendingCrawlResultFormComponent } from "./Entities/IzzyPendingCrawlResult/izzypendingcrawlresult.form.component";
import { IzzyPersonSkillFormComponent } from "./Entities/IzzyPersonSkill/izzypersonskill.form.component";
import { IzzySLAPolicyFormComponent } from "./Entities/IzzySLAPolicy/izzyslapolicy.form.component";
import { IzzyScopeFormComponent } from "./Entities/IzzyScope/izzyscope.form.component";
import { IzzySettingExtensionFormComponent } from "./Entities/IzzySettingExtension/izzysettingextension.form.component";
import { IzzySkillFormComponent } from "./Entities/IzzySkill/izzyskill.form.component";
import { IzzySkillIssueTypeFormComponent } from "./Entities/IzzySkillIssueType/izzyskillissuetype.form.component";
import { IzzyTicketMergeFormComponent } from "./Entities/IzzyTicketMerge/izzyticketmerge.form.component";
import { IzzyTicketNumberSequenceFormComponent } from "./Entities/IzzyTicketNumberSequence/izzyticketnumbersequence.form.component";
import { IzzyTicketSLAStateFormComponent } from "./Entities/IzzyTicketSLAState/izzyticketslastate.form.component";
import { IzzyTicketSuggestionFormComponent } from "./Entities/IzzyTicketSuggestion/izzyticketsuggestion.form.component";
import { IzzyTicketTeamFormComponent } from "./Entities/IzzyTicketTeam/izzyticketteam.form.component";
import { IzzyTicketTeamMemberFormComponent } from "./Entities/IzzyTicketTeamMember/izzyticketteammember.form.component";
   

@NgModule({
declarations: [
    IzzyIzzyActionCategoryFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_0 { }
    


@NgModule({
declarations: [
    IzzyPendingCrawlResultFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_1 { }
    


@NgModule({
declarations: [
    IzzyIzzyActionFormComponent,
    IzzyTicketNumberSequenceFormComponent,
    IzzyTicketSuggestionFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_4 { }
    


@NgModule({
declarations: [
    IzzyChannelTypeActionFormComponent,
    IzzyTicketSLAStateFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_5 { }
    


@NgModule({
declarations: [
    IzzyMacroFormComponent,
    IzzyTicketMergeFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_6 { }
    


@NgModule({
declarations: [
    IzzyOrganizationActionFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_7 { }
    


@NgModule({
declarations: [
    IzzyTicketTeamFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_11 { }
    


@NgModule({
declarations: [
    IzzyChannelExtensionFormComponent,
    IzzyCredentialTypeExtensionFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_12 { }
    


@NgModule({
declarations: [
    IzzySkillFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_13 { }
    


@NgModule({
declarations: [
    IzzyPersonSkillFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_16 { }
    


@NgModule({
declarations: [
    IzzyAssignmentRuleFormComponent,
    IzzyTicketTeamMemberFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_17 { }
    


@NgModule({
declarations: [
    IzzyAutomationRuleFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_19 { }
    


@NgModule({
declarations: [
    IzzySkillIssueTypeFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_20 { }
    


@NgModule({
declarations: [
    IzzyChannelActionFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_21 { }
    


@NgModule({
declarations: [
    IzzyChannelMessageNoteFormComponent,
    IzzyScopeFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_22 { }
    


@NgModule({
declarations: [
    IzzySettingExtensionFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_23 { }
    


@NgModule({
declarations: [
    IzzyChannelMessageAttachmentFormComponent,
    IzzyIzzyActionOrganizationFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_25 { }
    


@NgModule({
declarations: [
    IzzyChannelTypeExtensionFormComponent,
    IzzyCredentialExtensionFormComponent,
    IzzyIssueTicketNumberFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_28 { }
    


@NgModule({
declarations: [
    IzzyChannelMessageFormComponent,
    IzzySLAPolicyFormComponent
],
imports: [
    CommonModule,
    FormsModule,
    BaseFormsModule,
    EntityViewerModule,
    LinkDirectivesModule
],
exports: [
]
})
export class GeneratedForms_SubModule_30 { }
    


@NgModule({
declarations: [
],
imports: [
    GeneratedForms_SubModule_0,
    GeneratedForms_SubModule_1,
    GeneratedForms_SubModule_4,
    GeneratedForms_SubModule_5,
    GeneratedForms_SubModule_6,
    GeneratedForms_SubModule_7,
    GeneratedForms_SubModule_11,
    GeneratedForms_SubModule_12,
    GeneratedForms_SubModule_13,
    GeneratedForms_SubModule_16,
    GeneratedForms_SubModule_17,
    GeneratedForms_SubModule_19,
    GeneratedForms_SubModule_20,
    GeneratedForms_SubModule_21,
    GeneratedForms_SubModule_22,
    GeneratedForms_SubModule_23,
    GeneratedForms_SubModule_25,
    GeneratedForms_SubModule_28,
    GeneratedForms_SubModule_30
]
})
export class GeneratedFormsModule { }
    
// Note: LoadXXXGeneratedForms() functions have been removed. Tree-shaking prevention
// is now handled by the pre-built class registration manifest system.
// See packages/CodeGenLib/CLASS_MANIFEST_GUIDE.md for details.
    